/**
 * Destino: atraso após a última mensagem do lead (+ mensagem opcional no card).
 */
import React from 'react';
import Select from '../../../../components/ui/Select';
import Input from '../../../../components/ui/Input';
import { FOLLOW_UP_DELAY_UNIT_OPTIONS } from '../followUp.constants';
import type { FollowUpDelayUnit } from '../types';
import FollowUpMessageEditor from './FollowUpMessageEditor';

interface FollowUpTriggerFieldsProps {
    fieldId: string;
    delayValue: number;
    delayUnit: FollowUpDelayUnit;
    onDelayValueChange: (value: number) => void;
    onDelayUnitChange: (unit: FollowUpDelayUnit) => void;
    message?: string;
    onMessageChange?: (text: string) => void;
    mediaUrl?: string | null;
    onMediaChange?: (url: string | null) => void;
}

export default function FollowUpTriggerFields({
    fieldId,
    delayValue,
    delayUnit,
    onDelayValueChange,
    onDelayUnitChange,
    message,
    onMessageChange,
    mediaUrl,
    onMediaChange,
}: FollowUpTriggerFieldsProps) {
    const handleDelayValueChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const next = Number.parseInt(event.target.value, 10);
        onDelayValueChange(Number.isNaN(next) || next < 1 ? 1 : next);
    };

    const trigger = (
        <section className="flex flex-col gap-s2" aria-labelledby={`${fieldId}-trigger`}>
            <h4
                id={`${fieldId}-trigger`}
                className="text-xs font-semibold uppercase tracking-wide text-muted"
            >
                Disparar quando
            </h4>
            <div className="flex flex-wrap items-center gap-s2 rounded-xl border border-border bg-background p-s3 sm:gap-s3">
                <span className="text-sm text-default">Última mensagem do lead foi há</span>
                <div className="flex shrink-0 items-center gap-s2">
                    <Input
                        id={`${fieldId}-delay-value`}
                        name={`${fieldId}-delay-value`}
                        type="number"
                        min={1}
                        inputSize="sm"
                        value={delayValue}
                        onChange={handleDelayValueChange}
                        aria-label="Quantidade de tempo"
                        containerClassName="w-20"
                        className="text-center"
                    />
                    <Select
                        id={`${fieldId}-delay-unit`}
                        name={`${fieldId}-delay-unit`}
                        value={delayUnit}
                        onChange={(event) => onDelayUnitChange(event.target.value as FollowUpDelayUnit)}
                        selectSize="sm"
                        aria-label="Unidade de tempo"
                        containerClassName="w-32"
                        options={FOLLOW_UP_DELAY_UNIT_OPTIONS.map((opt) => ({
                            value: opt.value,
                            label: opt.label,
                        }))}
                    />
                </div>
            </div>
        </section>
    );

    if (!onMessageChange || !onMediaChange) return trigger;

    return (
        <div className="flex flex-col gap-s4">
            {trigger}
            <FollowUpMessageEditor
                fieldId={fieldId}
                value={message ?? ''}
                onChange={onMessageChange}
                mediaUrl={mediaUrl}
                onMediaChange={onMediaChange}
            />
        </div>
    );
}
